import apiCall from './api'
import apiPostCall from './apiPost'
import apiSubCall from './apiSub'
import apiSubPostCall from './apiSubPost'
// 指定のT_PGM_SUBJECT.idのファイルがダウンロード済かチェックする
window.mediaCheckDirectory = (id, callback=null, failure=null) => {
	apiCall('media/checkdirectory', id, callback , failure)
}
// 指定のT_PGM_SUBJECT_FILES.idのファイルがダウンロード済かチェックする
window.mediaCheckFile = (id, callback=null, failure=null) => {
	apiCall('media/checkfile', id, callback , failure)
}
// 指定のT_PGM_SUBJECT.idのファイルがダウンロード済かチェックする
window.mediaCheckFiles = (id, callback=null, failure=null) => {
	apiCall('media/checkfiles', id, callback , failure)
}
// 指定のT_PGM_SUBJECT_FILES.idのファイルを指定のフォルダにダウンロードする
window.mediaDownload = (id, callback=null, failure=null) => {
	apiCall('media/download', id, callback, failure)
}
// 指定のT_PGM_SUBJECT.idの登録ファイルをすべて指定のフォルダにダウンロードする
window.mediaDownloads = (id, callback=null, failure=null) => {
	apiCall('media/downloads', id, callback, failure)
}
// 指定のT_PGM_SUBJECT_FILES.idで編集用にリネームダウンロードしてそのまま開く
window.mediaEdit = (id, callback=null, failure=null) => {
	apiCall('media/edit', id, callback, failure)
}
// 指定のT_PGM_SUBJECT.idのフォルダを開く
window.mediaOpenDirectory = async (id, callback=null, failure=null) => {
	apiCall('media/opendirectory', id, callback, failure)
}
// 指定のT_PGM_SUBJECT_FILES.idのファイルを開く
window.mediaOpenFile = async (id, callback=null, failure=null) => {
	apiCall('media/openfile', id, callback, failure)
}
// 指定のT_PGM_SUBJECT.idのフォルダを開く
window.mediaOpenFiles = async (id, callback=null, failure=null) => {
	apiCall('media/openfiles', id, callback, failure)
}
// 指定のT_PGM_SUBJECT.idのフォルダを開く
window.mediaOpenFilesBarcode = async (id, callback=null, failure=null) => {
	apiCall('media/openbarcode', id, callback, failure)
}
// 指定のT_PGM_SUBJECT.idのフォルダを開く
window.mediaOpenCopiedFiles = async (id, callback=null, failure=null) => {
	apiCall('media/opencopiedfiles', id, callback, failure)
}
// 指定のT_PGM_SUBJECT.idのフォルダを開く
window.mediaOpenCopiedDirectory = async (id, callback=null, failure=null) => {
	apiCall('media/opencopieddirectory', id, callback, failure)
}
// 指定のT_PGM_SUBJECT_FILES.idのファイルを指定+1回のフォルダにダウンロードする
window.mediaReceptDownload = (id, callback=null, failure=null) => {
	apiCall('media/receptdownload', id, callback, failure)
}
// 指定のT_PGM_SUBJECT.idの登録ファイルをすべて指定+1回のフォルダにダウンロードする
window.mediaReceptDownloads = (id, callback=null, failure=null) => {
	apiCall('media/receptdownloads', id, callback, failure)
}

// 指定のT_PGM_SUBJECT.idでフォルダ内容を再アップロード
window.mediaRewrite = async (id, callback=null, failure=null) => {
	apiCall('media/rewrite', id, callback, failure)
}
const statusCallback = (callback, failure = null) => {
	apiCall('media/access', 'status', (response)=>{
		if (response.result==='OK') {
			callback()
		} else if (response.result==='ER') {
			failure();
		} else {
			document.getElementById('progress').innerText = response.step+'/'+response.total+'のファイルをコピー中です。'
			setTimeout(()=>statusCallback(callback, failure),1000)
		}
	})
}
// 指定のT_PGM_SUBJECT.idでフォルダ内容を再アップロード
//window.mediaRewriteExclusive = async (id, params, callback=null, failure=null) => {
window.mediaRewriteExclusive = async (id, params, callback=null, failure=null) => {
	apiCall('media/access', 'key', (response)=>{
		if (response.accesskey) {
			console.log('Exclusive Start')
			apiSubPostCall('media/rewrite', id+'/'+response.accesskey, params)
			//apiSubCall('media/rewrite', id+'/'+response.accesskey)
			setTimeout(()=>statusCallback(callback, failure),1000)
		} else {
			console.log('Exclusive Retry')
            setTimeout(() => mediaRewriteExclusive(id, params, callback, failure), 1000);
		}
	})
	//apiCall('media/rewrite', id, callback, failure)
}

// 指定のT_PGM_SUBJECT.idでフォルダ内容を一次フォルダにコピー
window.mediaCopy = async (id, files, progress=null, callback=null, failure=null) => {
	try {
		for(let index=0; index<files.length;index++) {
			const formData = new FormData()
			formData.append('file',files[index])
			const fileCount = (index+1)/files.length
			const fileOffset = (index)/files.length
			const dividedProgress = (e) => progress(e,index,files.length)
			const response = await apiPostCall('media/copy', id+'?file_no='+index, formData, dividedProgress, null, failure)
		}
		if(callback) {
			callback()
		}
	} catch (e) {
		if(failure) {
			failure(e)
		}
	}
}

// 指定のT_PGM_SUBJECT.idでフォルダ内容を一次フォルダにコピー
window.mediaCopyExclusive = async (id, files, progress=null, callback=null, failure=null) => {
	try {
		for(let index=0; index<files.length;index++) {
			const formData = new FormData()
			formData.append('file',files[index])
			const fileCount = (index+1)/files.length
			const fileOffset = (index)/files.length
			const dividedProgress = (e) => progress(e,index,files.length)
			const response = await apiPostCall('media/copy', id, formData, dividedProgress, callback, failure)
		}
		if(callback) {
			callback()
		}
	} catch (e) {
		if(failure) {
			failure(e)
		}
	}
}
// 指定のT_PGM_SUBJECT.idのフォルダを開く
window.mediaAppLinks = async (id, callback=null, failure=null) => {
	apiCall('media/applinks', id, callback, failure)
}
window.mediaDeleteFile = async (id, callback=null, failure=null) => {
	apiCall('media/delete', id, callback, failure)
}
